import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { HomeComponent } from './home/home.component';
import { ActividadDetalleComponent } from './actividad-detalle/actividad-detalle.component';
import { CursoDetalleComponent } from './curso-detalle/curso-detalle.component';
import { RegistroComponent } from './registro/registro.component';
import { DeletedUserComponent } from './deleted-user/deleted-user.component';
import {CompraActividadAvisoComponent } from './compra-actividad-aviso/compra-actividad-aviso.component'
import { AvisoLegalComponent } from './avisoLegal/avisoLegal.component';
import { AvisoCookiesComponent } from './avisoCookies/avisoCookies.component';

const routes: Routes = [
  { path: '**', redirectTo: 'public/404'},
  {path: '',
  component: PublicComponent,
  children: [
    {
      path: 'inicio',
      component: HomeComponent,
    },
    {
      path: 'avisoLegal',
      component: AvisoLegalComponent,
    },
    {
      path: 'politicaCookies',
      component: AvisoCookiesComponent,
    },
    {
      path: 'registro',
      component: RegistroComponent,
    },
    {
      path: 'actividad',
      component: ActividadDetalleComponent,
    },
    {
      path: 'deleted-user',
      component: DeletedUserComponent,
    },
    {
      path: 'compra-actividad-aviso',
      component: CompraActividadAvisoComponent,
    }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule { }
